import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const idrCurrency = (value: number, minimumFractionDigits = 0, maximumFractionDigits = 0) => {
  const formatted = Intl.NumberFormat('id-ID', {
    currency: 'IDR',
    style: 'currency',
    maximumFractionDigits,
    minimumFractionDigits,
  })
    .format(value)
    .replace(' ', '')
    .replace('Rp', '');
  return `Rp${formatted}`;
};

export const UnitRegex = /^UA|^UB|^UC|^UD/;
export const SparepartRegex = /^SH|^SG|^SF|^SE|^SD|^SC|^SB|^SA|^LC|^LB|^LA/;
